import { HeroBanner } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import {
  MEMBERSHIP_MODELS,
  PLAYER_PORTALS_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';
export default {
  component: () => HeroBanner,
  mapEntryToProps: (
    entry: MEMBERSHIP_MODELS.HeroBanner & PLAYER_PORTALS_MODELS.HeroBanner,
  ) => kontentAiDataMapping.hero_banner(entry),
  depthParameter: 3,
};
